import { AnnounceAttachment as GQLItem } from '../../generated/graphql';
import { take } from '../../util';
import * as Attachment from '../Attachment/Attachment';

export type AnnounceAttachment = {
  attachmentId: number;
  attachment?: Attachment.Attachment;
  highlighted?: boolean;
};

export const fromGql = (item: GQLItem): AnnounceAttachment => ({
  ...take<AnnounceAttachment>(item, 'id', 'highlighted'),
  attachment: item.attachment ? Attachment.fromGql(item.attachment) : undefined,
});
